<!-- 活动申请 -->
<template>
  <div class="apply">
    <back />

    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
      <!-- 基本信息 -->
      <div class="box">
        <div class="title">活动信息：</div>
        <el-row class="dialog_row">
          <el-form-item class="item logo_pic" label="图片：" prop="picUrl">
            <el-upload class="logo_uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="action"
              :show-file-list="false" :on-success="handleSuccess" :before-upload="beforeUploads"
              :on-remove="handleRemoveLogo" :disabled="ruleForm.picUrl ? true : false">
              <img v-if="ruleForm.picUrl" :src="ruleForm.picUrl" class="logoimg">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <i v-if="ruleForm.picUrl" class="delpic el-icon-error" @click="handleRemoveLogo"></i>
          </el-form-item>
        </el-row>
        <el-row class="dialog_row">
          <el-col :span="8">
            <el-form-item class="item" label="项目应用：" prop="project">
              <el-select v-model="ruleForm.project" placeholder="请选择" clearable>
                <el-option label="养长福" :value="1"></el-option>
                <el-option label="脑健康" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="item" label="最大报名数：" prop="maxNum">
              <el-input v-model="ruleForm.maxNum" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item class="item" label="活动结束时间：" prop="endTime">
              <el-date-picker v-model="ruleForm.endTime" type="datetime" placeholder="请选择"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="item" label="活动名称：" prop="activityName">
              <el-input v-model="ruleForm.activityName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item class="item" label="报名截止时间：" prop="deadline">
              <el-date-picker v-model="ruleForm.deadline" type="datetime" placeholder="请选择"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
            <el-form-item class="item" label="活动价格(元)：" prop="price">
              <el-input v-model="ruleForm.price" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="item" label="活动分类：" prop="categoryName">
              <el-cascader :options="cascaderOptions" placeholder="选择分类" v-model="ruleForm.categoryName"
                :props="cascaderprops" collapse-tags clearable @change="handleSelectCategory"></el-cascader>
            </el-form-item>
            <el-form-item class="item" label="活动开始时间：" prop="startTime">
              <el-date-picker v-model="ruleForm.startTime" type="datetime" placeholder="请选择"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
            <el-form-item class="item" label="集合时间：" prop="gatherTime">
              <el-date-picker v-model="ruleForm.gatherTime" type="datetime" placeholder="请选择"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="dialog_row">
          <el-col :span="15">
            <el-form-item class="" label="集合地点：" prop="gatherPlace">
              <el-input v-model="ruleForm.gatherPlace" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="dialog_row">
          <el-col :span="22">
            <el-form-item class="item" label="活动介绍：" prop="introduction">
              <vue-word-editor v-model="ruleForm.introduction" :config="config" ref="wordeditor"></vue-word-editor>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <div class="submit-btn">
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import VueWordEditor from "vue-word-editor"
import "quill/dist/quill.snow.css"
export default {
  components: {
    VueWordEditor
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          const now = new Date()
          now.setHours(0, 0, 0, 0)
          const targetDate = new Date(time)
          targetDate.setHours(0, 0, 0, 0)
          return targetDate < now
        },
      },
      cascaderOptions: [],
      cascaderprops: {
        checkStrictly: false,
        emitPath: false,
        value: "categoryId",
        label: "categoryName",
        children: "children",
      },
      ruleForm: {
        picUrl: "",
        project: "",
        maxNum: "",
        endTime: "",
        activityName: "",
        deadline: "",
        categoryName: "",
        startTime: "",
        gatherTime: "",
        gatherPlace: "",
        introduction: "",
        firstCategoryId: "",
        secondCategoryId: "",
      },
      rules: {
        picUrl: [{
          required: true,
          message: "请上传图片",
          trigger: "blur",
        },],

        project: [{
          required: true,
          message: "请选择项目应用",
          trigger: "blur",
        },],
        maxNum: [{
          pattern: /^\d+(\.\d{1,2})?$/,
          message: "只能输入数字",
          trigger: "blur",
        },],
        endTime: [{
          required: true,
          message: "请选择活动结束时间",
          trigger: "blur",
        },],
        activityName: [{
          required: true,
          message: "请输入活动名称",
          trigger: "blur",
        },],
        deadline: [{
          required: true,
          message: "请选择报名截止时间",
          trigger: "blur",
        },],
        price: [{
          required: true,
          message: "请输入活动价格",
          trigger: "blur",
        },
        {
          pattern: /^\d+(\.\d{1,2})?$/,
          message: "只能输入数字",
          trigger: "blur",
        },
        ],
        categoryName: [{
          required: true,
          message: "请选择活动分类",
          trigger: "blur",
        },],
        startTime: [{
          required: true,
          message: "请选择活动开始时间",
          trigger: "blur",
        },],
        introduction: [{
          required: true,
          message: "请输入活动介绍",
          trigger: "blur",
        },],
      },
      // 图片上传
      fileList: [],
      action: this.$axios.defaults.baseURL + this.$api.uploadFile,
      config: {
        placeholder: "请输入内容",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["blockquote", "code-block"],
            ["link", "image"],
            [{
              header: 1
            }, {
              header: 2
            }], // custom button values
            [{
              list: "ordered"
            }, {
              list: "bullet"
            }, {
              list: "check"
            }],
            [{
              script: "sub"
            }, {
              script: "super"
            }], // superscript/subscript
            [{
              indent: "-1"
            }, {
              indent: "+1"
            }], // outdent/indent
            [{
              direction: "rtl"
            }], // text direction
          ],
        },
        // 上传图片的配置
        uploadImage: {
          url: this.$axios.defaults.baseURL + this.$api.uploadFile,
          name: "multipartFile",
          headers: this.getToken(),
          // res是结果，insert方法会把内容注入到编辑器中，res.data.url是资源地址
          uploadSuccess: (res, insert) => {
            insert(res.data.result.fileUrl)
          },
          showProgress: false,
        },
      },
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.id) {
      to.meta.title = "编辑活动";
    } else {
      to.meta.title = "新增活动";
    }
    next();
  },
  mounted() {
    document.title = this.$route.meta.title;
  },
  watch: {
    '$route'(to, from) {
      document.title = to.meta.title;
    }
  },
  created() {
    if (this.$route.query.positionId) {
      this.selectPositionInfoDetail()
      this.editQuery = this.$route.query.positionId || ""
    }
    this.getCategoryList()
  },

  methods: {
    getToken() {
      return {
        Token: JSON.parse(localStorage.getItem("vuex")).token,
      }
    },
    // 分类
    getCategoryList() {
      this.$axios
        .get(this.$api.getCategoryList, {
          params: {
            page: 1,
            pageSize: 9999,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.cascaderOptions = res.result.list
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 编辑详情
    selectPositionInfoDetail() {
      this.$axios
        .get(this.$api.selectPositionInfoDetail, {
          params: {
            positionId: this.$route.query.positionId,
          },
        })
        .then(res => {
          if (res.code === 100) {
            const row = res.result
            this.ruleForm = row
            this.$set(this.ruleForm, "categoryName", row.categoryId)
            this.$refs.wordeditor.editor.root.innerHTML = row.introduction
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 递归查找categoryId匹配的项
    findCategoryById(id, options) {
      for (let i = 0; i < options.length; i++) {
        if (options[i].categoryId === id) {
          this.ruleForm.firstCategoryId = options[i].parentCategoryId
          return
        }
        if (options[i].children && options[i].children.length > 0) {
          // 如果当前项有子项，递归查找
          this.findCategoryById(id, options[i].children)
        }
      }
    },
    handleSelectCategory(value) {
      this.$set(this.ruleForm, "secondCategoryId", value)
      if (value) {
        this.findCategoryById(value, this.cascaderOptions)
      }
    },
    onChange(value) {
      this.ruleForm.positionDuty = value
    },
    // 表单校验
    submitForm(formName) {
      this.ruleForm.introduction = this.$refs.wordeditor.editor.root.innerHTML
      this.$refs[formName].validate(valid => {
        if (valid) {
          const formData = {
            age: this.ruleForm.age,
            areaType: this.ruleForm.areaType,
            eatLive: this.ruleForm.eatLive,
            education: this.ruleForm.education,
            firstCategoryId: this.ruleForm.firstCategoryId,
            secondCategoryId: this.ruleForm.secondCategoryId,
            language: this.ruleForm.language,
            positionDuty: this.ruleForm.positionDuty,
            positionName: this.ruleForm.positionName,
            minRange: this.ruleForm.minRange,
            maxRange: this.ruleForm.maxRange || null,
            validStartDate: this.ruleForm.validityPeriod[0],
            validEndDate: this.ruleForm.validityPeriod[1],
            workDay: this.ruleForm.workDay,
            workExperience: this.ruleForm.workExperience,
            workHour: this.ruleForm.workHour,
            workLocation: this.ruleForm.workLocation,
            peopleNumber: this.ruleForm.peopleNumber || null,
          }
          if (this.$route.query.positionId) {
            // 如果存在 this.$router.query.positionId
            formData.positionId = this.$route.query.positionId
            this.$axios
              .post(this.$api.updatePositionInfo, formData)
              .then(res => {
                if (res.code == 100) {
                  this.$message.success(res.desc)
                  this.$router.go(-1)
                  this.resetForm()
                }
              })
              .catch(err => {
                this.$message.error(err.desc)
              })
          } else {
            // 否则调用添加接口 insertProductInfo
            this.$axios
              .post(this.$api.insertPositionInfo, formData)
              .then(res => {
                if (res.code == 100) {
                  this.$message.success(res.desc)
                  this.$router.go(-1)
                  this.resetForm()
                }
              })
              .catch(err => {
                this.$message.error(err.desc)
              })
          }
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    // 重置表单
    resetForm() {
      this.ruleForm = {}
      this.$refs.ruleForm.resetFields()
    },
    beforeUploads(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/jpg" || file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!");
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isJPG && isLt5M;
    },
    handleRemoveLogo() {
      this.ruleForm.picUrl = ""
    },
    handleSuccess(res) {
      if (res.code == 100) {
        this.ruleForm.picUrl = res.result.fileUrl;
      } else {
        this.$message({
          showClose: true,
          message: res.desc,
          type: "error",
        });
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.submit-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 100px;
}

.item {
  margin-right: 30px;

  .el-input,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 300px;
  }
}

.flex {
  display: flex;

  ::v-deep .el-input {
    width: 80px;
    margin: 0 10px;
  }

  .timeTxt {
    color: #272727;
    font-size: 16px;
  }
}

.title {
  font-size: 20px;
  margin-bottom: 30px;
}

.dialog_row {
  ::v-deep .el-form-item__label {
    color: #272727;
    font-size: 16px;
    padding-right: 15px;
  }

  // 内容
  ::v-deep .el-textarea__inner {
    resize: none;
    border-radius: 10px;
    height: 172px;
  }
}

// 图片
.logo_pic {
  position: relative;

  ::v-deep .el-form-item__content {
    width: 100px;
    height: 100px;
  }

  .logo_uploader {
    ::v-deep .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    ::v-deep .el-upload:hover {
      border-color: $themes;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: $themes;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }

    .logoimg {
      width: 100px;
      height: 100px;
      display: block;
      object-fit: cover;
    }
  }

  .delpic {
    position: absolute;
    top: -12px;
    color: red;
    font-size: 20px;
    cursor: pointer;
  }

  .delpic1 {
    left: 90px;
  }

  .delpic2 {
    left: 210px;
  }

  .delpic3 {
    left: 325px;
  }
}

#vue-editor-wrapper {
  height: 200px;
}
</style>
